module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <my-cuenta-consultar></my-cuenta-consultar>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/cuentas/cuentas.component.html
// module id = ./src/app/Contabilidad/cuentas/cuentas.component.html
// module chunks = main